export default __webpack_public_path__ + "files/FP5_Financial_Instruments_Equity.pdf";